import GMLV1ToSaltDefault from'./GmlV1ToSalt';export const GmlV1ToSalt=GMLV1ToSaltDefault;